export default __webpack_public_path__ + "static/media/antonioAvatar.ecb57800.jpg";